
import indicator from '../components/indicator';
import menu from '../components/menu';
import scroll from '../components/scroll';
import waypoints from '../components/waypoints';
import hubspot_form from '../components/hubspot_form';
import 'slick-carousel/slick/slick.min';
import 'select2/dist/js/select2.full';
import 'select2/dist/js/select2.full';
import 'jquery.cookie/jquery.cookie.js';

export default {
    init() {
        // JavaScript to be fired on all pages

        let body = jQuery('body');

        // detect Safari
        if ( navigator.userAgent.match(/Version\/[\d.]+.*Safari/) ) {
            body.addClass('isSafari');
        }

        // detect iOS
        if ( navigator.userAgent.match(/iPad|iPhone|iPod/) ) {
            body.addClass('isIOS');
        }



        jQuery(function () {

            indicator.init();
            menu.init();
            scroll.init();
            waypoints.init();
            hubspot_form.init();

            // Announcement Slider
            let announcementSlider = jQuery('.announcement-slider');
            announcementSlider.slick({
                autoplay: true,
                autoplaySpeed: 4000,
            });

            let floatFormArea = jQuery('.float-form-area-in-warp');
            if(floatFormArea.length == 0){
                jQuery('.subscribe-button').addClass('subscribe-btn');
            }
            jQuery('.subscribe-btn').on('click',function(e){
                e.preventDefault();
                jQuery('.subscribe-form').addClass('subscribe-form-open');
                jQuery('html').addClass('scroll-lock');
            });
            jQuery('.subscribe-form__closebtn, .subscribe-form__overlay').on('click',function(){
                jQuery('.subscribe-form').removeClass('subscribe-form-open');
                jQuery('html').removeClass('scroll-lock');
            });
            jQuery('.float-form-area-in-warp').each(function(){
                var formDataId = jQuery(this).data('form-id');
                if(formDataId){
                    jQuery('[href="#'+formDataId+'"]').addClass('float-form-area-open-button');
                }
            });
            jQuery('body').on('click', '.float-form-area-open-button', function (e) {
                if(!jQuery(this).is('a:not([href^="#"])')) {
                    var formId = jQuery(this).attr('href');
                    formId = formId.replace('#','');
                    if(formId){
                        e.preventDefault();
                        jQuery('.float-form-area-in-warp').removeClass('float-form-area-in-warp-open');
                        jQuery('.float-form-area').addClass('float-form-area-open');
                        jQuery('[data-form-id='+formId+']').addClass('float-form-area-in-warp-open');
                        jQuery('html').addClass('scroll-lock');
                    }
                }
            });
            jQuery('.float-form-area__closebtn, .float-form-area__overlay').on('click',function(){
                jQuery('.float-form-area').removeClass('float-form-area-open');
                jQuery('html').removeClass('scroll-lock');
            });

            jQuery('.close-popup, .portfolio-showcase-arrow, .samssna-prev, .samssna-next, .subscribe-form__closebtn, .float-form-area__closebtn, .subscribe-btn, .c-hero-main__scroll-indicator span, .back-to-top, .c-hero__scroll, .tfgaifsf-area-label, .tfgai-list-item-block, .tfgai-list-item-photo, .pfgaifsf-area-label, .pfgai-list-item-photo, .pfgai-list-item-logo, .pfgai-list-item-categories').attr('role', 'button').attr('tabindex', '0');
            jQuery('.close-popup').attr('aria-label', 'Close');
            jQuery('.portfolio-showcase-prev-arrow, .samssna-prev').attr('aria-label', 'Previous slide');
            jQuery('.portfolio-showcase-next-arrow, .samssna-next').attr('aria-label', 'Next slide');
            jQuery('a[target="_blank"]').attr('aria-label', 'Opens in a new tab');
            jQuery('.c-cross-link__title, .pshfi-text').attr('role', 'heading');
            jQuery('.pfgai-list-item-logo').attr('aria-label', 'Portfolio');
            jQuery('button[type="submit"]').attr('aria-label', 'Submit');
            jQuery('.subscribe-form__closebtn, .float-form-area__closebtn').attr('aria-label', 'Close');

            jQuery('ul.menu').attr('role', 'navigation');
            jQuery('.c-menu__nav > ul > li').each(function(){
              if(jQuery(this).children().is('ul')){
                jQuery(this).find('> a').attr('aria-haspopup', 'true');
                jQuery(this).find('> a').attr('aria-expanded', 'false');
              }
            });

            jQuery(document).on('click','.menu-item-trigger',function(event){
              jQuery(event.target).parent().find('> a').attr('aria-expanded', function(_, val) {
                return val === 'true' ? 'false' : 'true';
              });
            });


            jQuery('.c-menu__nav > ul > li').on('mouseenter',function(){
                jQuery(this).siblings().addClass('menu-hover-item');
            });

            jQuery('.c-menu__nav > ul > li').on('mouseleave',function(){
                jQuery(this).siblings().removeClass('menu-hover-item');
            });

            jQuery('.content-with-side-image .cwsi-left p, .ps-slider-content p, .sams-overview p').attr('role', 'heading');
            jQuery('.link svg, .samssna-prev svg, .samssna-next svg, .search-form-wrap svg').attr('role', 'presentation');
            jQuery('[data-editor] a[target="_blank"]').attr('aria-label', 'Opens in a new tab');

            // jQuery('.back-to-top').click(function() {
            //     jQuery('html, body').animate({
            //         scrollTop: jQuery('body').offset().top,
            //     }, 2000);
            // });

            /**
            * Replace all SVG images with inline SVG
            */
            const convertImages = (query, callback) => {
                const images = document.querySelectorAll(query);
                images.forEach(image => {
                    if (!image.src.endsWith('.svg')) {
                        return;
                    }
                    fetch(image.src)
                        .then(res => {
                            if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                            return res.text();
                        })
                        .then(data => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(data, 'image/svg+xml');
                            const svg = doc.querySelector('svg');
                            if (!svg) throw new Error('No <svg> element found in fetched content');
                            if (image.id) svg.id = image.id;
                            svg.setAttribute('role', 'presentation');
                            image.classList.forEach(cls => svg.classList.add(cls));
                            if (!svg.hasAttribute('viewBox')) {
                                const width = svg.getAttribute('width') || 100;
                                const height = svg.getAttribute('height') || 100;
                                svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
                            }
                            image.parentNode.replaceChild(svg, image);
                        })
                        .then(() => callback && callback())
                        .catch(error => console.error('Error converting image to SVG:', error));
                });
            };

            // Example usage
            convertImages('img');

        });

        jQuery(window).on('scroll', function () {
            waypoints.init();
            var winH = jQuery(window).height();
            if(!jQuery.cookie('marketingPopup')) {
                if(jQuery(this).scrollTop() > winH && jQuery('.latest-news-email-popup').length > 0){
                    jQuery('body.home').addClass('latest-news-email-popup-active');
                    jQuery('body.news-insights').addClass('latest-news-email-popup-active');
                }
            }
        });


        jQuery('.latest-news-email-popup .close-popup, .latest-news-email-popup-overlay').on('click',function(){
            jQuery.cookie('marketingPopup', 'true', { expires: 2, path: '/' });
            jQuery('body').removeClass('latest-news-email-popup-active');
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        jQuery(document).bind('gform_confirmation_loaded', function(){
            jQuery.cookie('marketingPopup', 'true', { expires: 2, path: '/' });
        });
    },
}





// WEBPACK FOOTER //
// ./scripts/routes/common.js